module.exports = __webpack_public_path__ + "static/media/FlorianGraf_Menu.d157dfc5.svg";